import { render } from "./EditMemberProfileStep1Modal.vue?vue&type=template&id=10510dda"
import script from "./EditMemberProfileStep1Modal.vue?vue&type=script&lang=js"
export * from "./EditMemberProfileStep1Modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__